export enum OrderStateEnums {
  open = 1,
  initialClose = 2,
  finalClose = 3,
  annulled = 4,
}

export enum OrderTypeEnums {
  rental = 1,
  newSale = 2,
  usedSale = 3,
  service = 4,
}